import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Unregister any existing service workers — PWA caching caused persistent
// "Update available" loops after deployments. Clean up all registered SWs
// and caches so the app always loads fresh from the network.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.unregister());
  });
}
if ("caches" in window) {
  caches.keys().then((names) => names.forEach((n) => caches.delete(n)));
}

createRoot(document.getElementById("root")!).render(<App />);
